import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpMethods } from '@cbre/http';
import { EntityType } from '@shared/models/entity-enum';

@Injectable({
  providedIn: 'root',
})
export class BrokerFeedbackService extends HttpMethods {
  private _usages$ = new BehaviorSubject<string>('All');
  public usages$ = this._usages$.asObservable();
  constructor(http: HttpClient) {
    super(http);
  }

  updateUsages(usages: string) {
    this._usages$.next(usages);
  }

  private modifyFeedbackNotesForProperty(
    feedbackNotes: string,
    entityType: string,
    tabName: string,
    usage: string
  ): string {
    if (this.isPropertyEntityWithNonAttachmentTab(entityType, tabName)) {
      return `${usage || 'All'}/${feedbackNotes}`;
    }
    return feedbackNotes;
  }

  private isPropertyEntityWithNonAttachmentTab(entityType: string, tab: string): boolean {
    const excludedTabs = ['ATTACHMENTS', 'attachments'];
    return entityType === EntityType.Property && !excludedTabs.includes(tab);
  }

  brokerFeedback(
    entity: string,
    recordId: number,
    userId: number,
    feedbackNotes: string,
    tabName: string,
    usage: string
  ): Observable<{ results: any[] }> {
    feedbackNotes = this.modifyFeedbackNotesForProperty(feedbackNotes, entity, tabName, usage);
    return this.httpPost('/audit/feedback', {
      entity,
      recordId,
      userId,
      feedbackNotes,
    });
  }
}
